const MESSAGE_TYPES = {
    message: "message",
    success: "success",
    error: "error",
};

export default MESSAGE_TYPES;
